/**
 * Return the parent element
 *
 * @param element
 * @param selector
 */

const getParent = (element, selector) =>
{

    // Stop if we reached the body tag
    if(element === document.body) return null

    // Check if the element matches the selector
    const matches = element.matches(selector)

    // Return the element if we have a match
    if(matches) return element

    // Check the parent element for a match
    if(element.parentNode) return getParent(element.parentNode, selector)

    // Stop
    return null

}

/**
 * Setup the tabs
 *
 * @param context
 */

export const setupTabs = (context) => {

    // Get the triggers
    const triggers = context.querySelectorAll('.tabs-list a')

    // For each trigger
    for(const trigger of triggers) {

        // Handle the click event
        trigger.addEventListener('click', function(event){

            // Prevent default action
            event.preventDefault()

            // Stop if current tab is active
            if(this.classList.contains('active')) return

            // Get the active tab
            const activeTab = this.parentNode.querySelectorAll('a.active')[0]

            // Get the tabs container
            const tabsContainer = getParent(this, '.tabs-container')

            // Get the tabs content
            const tabsContent = tabsContainer.querySelectorAll('.tabs-content')[0]

            // Get the active tab
            const activeTabContent = tabsContent.querySelectorAll('.tab-content.active')[0]
            const activeTabIndex = Array.prototype.indexOf.call(this.parentElement.children, this)
            const newTabContent = tabsContent.children[activeTabIndex]

            // Remove the active class
            activeTab.classList.remove('active')
            activeTabContent.classList.remove('active')

            // Make the clicked tab active
            this.classList.add('active')
            newTabContent.classList.add('active')

        })

    }

}

/**
 * Tabs Component
 *
 * @constructor
 */

export default (app) => {
    setupTabs(document)
}
